import { bindable, autoinject, transient } from "aurelia-framework";
import { EmailRecipientTypeEnum, VettingActionEnum } from "../../../../models/vetting/vetting.models";
import { VettingService } from "../../../../services/vetting/vetting.service";

@autoinject()
@transient()
export class VettingContactMessageView {

    @bindable()
    vettingContactEmails: { email: string, emailRecipientTypeId: number, isShipManager: boolean }[] = [];

    @bindable()
    vettingContactMessage: string;

    @bindable()
    vetId: number;

    @bindable()
    readonly: boolean;

    @bindable()
    requestorOnly: boolean;

    constructor(private vetClientService: VettingService) { }

    bind() {
        if (!this.readonly) {
            this.checkForVettingEmails();
        }
    }
    
    removeEmail(index: number) {
        this.vettingContactEmails.splice(index, 1);
    }

    addEmail() {

        this.vettingContactEmails.push({
            email: null,
            emailRecipientTypeId: EmailRecipientTypeEnum.To,
            isShipManager: false
        });
    }

    async checkForVettingEmails() {
        if (!this.vettingContactEmails || this.vettingContactEmails.length == 0) {
            const vet = await this.vetClientService.getVet(this.vetId, false);

            this.vettingContactEmails = vet.initialEmailsForCorrespondence.filter(x => this.requestorOnly ? !x.isShipManagerEmail : true).map(x => {
                return { email: x.email, emailRecipientTypeId: x.emailRecipientTypeId, recipientType: x.recipientType, isShipManager: x.isShipManagerEmail };
            });

            if (this.vettingContactEmails.length == 0) {
                const alertEmails = await this.vetClientService.getBusinessUnitVetAlertRecipients(this.vetId, VettingActionEnum.VetRequiresFurtherInformation);

                if (alertEmails.length > 0) {
                    this.vettingContactEmails = alertEmails.filter(x => x.email).map(x => {
                        return { email: x.email, emailRecipientTypeId: x.emailRecipientTypeId, isShipManager: false }
                    });
                }
            }
        }
    }
}